import { useDataChange, useDataValue } from 'Simple/Data.js'

export function useOnChange(props) {
  let change = useDataChange({
    context: 'credit_card_capture',
    viewPath: props.viewPath,
  })
  let person = useDataValue({
    context: 'credit_card_capture',
    path: 'person',
    viewPath: props.viewPath,
  })
  let responsible_person = useDataValue({
    context: 'credit_card_capture',
    path: 'responsible_person',
    viewPath: props.viewPath,
  })
  return function onChange(card_owner) {
    change(next => {
      next.card_owner = card_owner
      next.effective_person =
        card_owner === 'responsible_person' && responsible_person
          ? responsible_person
          : person
    })
  }
}
